
    import Vue from "vue";
    import Component from "vue-class-component";
    import { Prop } from "vue-property-decorator";
    import { VisitSearchResult } from "@/model/VisitSearchResult";
    import Utils from "@/utilities/Utils";

    @Component({})
    export default class VisitViewHeader extends Vue {

        @Prop({ required: true })
        visitSearchResult!: VisitSearchResult;

        get shouldShowResult(): boolean {
            return this.visitSearchResult.visit?.answers?.length > 0
                && Utils.hasDateValue(this.visitSearchResult.visit.completed);
        }
    }
